import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { useState } from 'react';
import { useStartPopup } from '@/hooks/useStartPopup';
import { NAV_PATH } from '@/router/constants';

interface BannerLink {
	src: string;
	action: 'link' | 'popup';
	link: string;
	target?: string;
}

interface BannerPopup {
	src: string;
	action: 'popup';
}

type Bsnnaer = BannerLink | BannerPopup;

const popupImages = {
	banner1: require('@/assets/images/common/img_popup1.jpg'),
	banner2: require('@/assets/images/common/img_popup2.jpg')
};

const popupBanner: Bsnnaer[] = [
	{
		src: popupImages.banner2,
		action: 'link',
		link: NAV_PATH.FUNCTION.CONVENIENCE + '#pharosAI',
		target: '_self'
	},
	{
		src: popupImages.banner1,
		action: 'popup',
		link: ''
	}
];

const PopupBanner = () => {
	const [bannerClosed, setBannerClosed] = useState(false); // 닫기 여부
	const { openStartPopup } = useStartPopup();

	const handleBannerClick = (slide: Bsnnaer) => {
		if (slide.action === 'popup') {
			openStartPopup();
			return;
		}

		if (slide.target === '_blank') {
			window.open(slide.link, '_blank', 'noopener,noreferrer');
		} else {
			window.location.href = slide.link;
		}
	};

	return (
		<div className={`popup-banner ${!bannerClosed ? 'active' : ''}`}>
			<Swiper
				modules={[Pagination, Autoplay]}
				spaceBetween={0}
				slidesPerView={1}
				loop
				speed={1000}
				autoplay={{
					delay: 5000
				}}
				observer={true}
				observeParents={true}>
				{popupBanner.map((slide, index) => (
					<SwiperSlide key={index}>
						<button type="button" onClick={() => handleBannerClick(slide)} style={{ all: 'unset', cursor: 'pointer' }}>
							<img src={slide.src} alt="" />
						</button>
					</SwiperSlide>
				))}
				<div className="swiper-pagination"></div>
			</Swiper>

			<div className="popup-banner-btns">
				<button type="button" className="popup-banner-btn btn1 hidden">
					일주일간 보지 않기
				</button>
				<button type="button" className="popup-banner-btn btn2" onClick={() => setBannerClosed(true)}>
					닫기
				</button>
			</div>
		</div>
	);
};

export default PopupBanner;
